import React from 'react'
import { Redirect, Route, withRouter } from 'react-router-dom'
import { addLocaleData, IntlProvider } from 'react-intl'

import en from 'react-intl/locale-data/en'
import ja from 'react-intl/locale-data/ja'

import messages from '../../messages'
//import AppBar from './AppBar'
import AppBar from '../AppBar'
import '../../App.css'
import { Background, GuestBackground, sideMenuItemStyles } from './styles'
import Navigation from './Navigation'
import {checkJapanese, flattenMessages } from '../../lib'
import authenticate from '../authenticateHOC'

// Language dependencies
addLocaleData([...en, ...ja])

const Back = changeBackground(Background)

const Layout = ({component: Component, ...rest, show}) => {
  const sessionToken = sessionStorage.getItem('authToken')
  const localToken = localStorage.getItem('authToken')
  if ((sessionToken === null && localToken === null)) {
    return (
      <Redirect
        to={'/login'}
      />
    )
  }
  return (
    <Route
      {...rest}
      render={matchProps => (
        <IntlProvider
          locale={checkJapanese() ? 'ja' : 'en'}
          messages={flattenMessages(
            messages[checkJapanese() ? 'ja' : 'en']
          )}>
          <Back
            location={matchProps.location.pathname}
            className="min-h-inherit w-100 h-100">
            {rest.isCheckingUser ? (
              <div className="min-h-inherit w-100 flex justify-center items-center">
                Loading...
              </div>
            ) : (
              <div>
                <AppBar
                  location={matchProps.location.pathname}
                  openSidebar={rest.openSidebar}
                  toggleSidebar={rest.toggleSideBar}
                  view={rest.view}
                />
                <div className="min-h-inherit w-100">
                  <div className="w-100 flex">
                    <div className="fv-sidebar-container" style={{ height: '85vh'}}>
                      <Navigation {...rest} {...matchProps} />
                    </div>
                    <div className="fv-container ml3">
                      <Component
                        {...matchProps}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}
          </Back>
        </IntlProvider>
      )}
    />
  )
}

export default withRouter(authenticate(Layout))
Layout.defaultProps = {
  show: true
}

/**
 *
 *
 * @param {Object} Component
 * @returns The background as per guest or not
 */
function changeBackground(Component) {
  const BackgroundDiv = props =>
    <Component {...props} />
  return BackgroundDiv
}



// WEBPACK FOOTER //
// src/layouts/Domain/Layout.js